<template>
  <div class=" is-fullwidth">
    <div >
      <div class="is-pulled-left">
        <button class="button" :class="{'is-success' : this.include_hidden == true}" @click="updateIncludeHidden()">Include Hidden</button>
      </div>
      <div class="is-pulled-right mb-2" v-if="loading == false && trex_codes.length > 0">
            
            <input class="input" v-model="search" placeholder="search trex codes ..."/>
            
        </div>
        <br style="clear:both" />
      <div class="notification is-info" v-if="loading === true">Loading trex codes ...</div>
      <div class="notification is-warning" v-if="loading == false && filteredTrexCodes.length == 0">There are no trex codes to show</div>

      
      <div v-if="loading == false && filteredTrexCodes.length > 0">
          
          <table class="table is-hoverable is-fullwidth " id="garmentstable" >
            <thead>
              <th width="45">ID</th>
              <th>Name</th>
              <th>Num Stitches</th>
            <th width="60">&nbsp;</th>
                
            </thead>
            <tbody>
                  <tr v-for="row in filteredTrexCodes" v-bind:key="row.id" >
                    <td >{{row.id}}</td>
                    <td >{{row.name}}</td>
                      
                      <td>{{row.num_stitches}}</td>
                      
                      <td><button v-if="1==2" class="button is-small is-info" :disabled="working==true" >View</button></td>

            </tr>
            </tbody>
          </table>
        </div>
      
    </div>

    
  </div>
</template>

<script>


//import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      trex_codes: [],
      accessToken: '',
      include_hidden: false,
      search: '',
      working:false
      
    }
  },
   methods: {
    goBack() {
      //this.garment_id = 0
      this.getTrexCodes();
    },
    updateIncludeHidden()
    {
        this.include_hidden = !this.include_hidden
      this.getTrexCodes()
    },
      async getTrexCodes() {
        this.loading = true;
        UtilityService.getSimpleApiData(this.accessToken, "trex_codes?include_hidden=" + this.include_hidden).then(
               response => {
                this.trex_codes = response 
                this.loading = false;
               }
            );
      },
      
    
  },
  computed : {
    filteredTrexCodes: function () {
       
        let filteredTrexCodes =  this.trex_codes.filter(function(u) {
            if(  u.active == 1) 
            {
              return 1
            }
            
          })
         

          if(this.search != '' && this.search != null)
          {
            filteredTrexCodes = filteredTrexCodes.filter(row => row.name.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredTrexCodes
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getTrexCodes();
          
           
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

